import { InjectionToken } from '@angular/core';

import { EnvironmentConfig } from './environment-config.interface';

export const ENV = new InjectionToken<EnvironmentConfig>('ENV');